import { useState } from "react";
import { auth } from "../config/firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";

export default function Auth({ onGoogleLogin }) {
  const [isSignup, setIsSignup] = useState(false);
  // form email/password data
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);

  const handleEmailAuth = async (e) => {
    e.preventDefault();

    try {
      if (isSignup) {
        await createUserWithEmailAndPassword(auth, email, password);
      } else {
        await signInWithEmailAndPassword(auth, email, password);
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const handlePasswordReset = async () => {
    try {
      if (!email) {
        setError("Please enter your email for password reset");
        return;
      }
      await sendPasswordResetEmail(auth, email.trim());
      setError(null);
      alert("Password reset email sent! Check your inbox.(Spam too!)");
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="auth-container">
      {
        <div className="auth-card">
          <h2>Welcome to Listo 🛍️</h2>
          <p>{isSignup ? "Create your account" : "Sign in to continue"}</p>

          <form onSubmit={handleEmailAuth} className="auth-form">
            <input
              type="email"
              placeholder="Email"
              value={email}
              // this is controlled element
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              //  // this conrolled elements
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            {error && <p className="error-text">{error}</p>}
            <button type="submit" className="email-btn">
              {isSignup ? "Sign Up" : "Login"}
            </button>
            <p className="forgot-password">
              <span
                onClick={handlePasswordReset}
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "blue",
                }}
              >
                Forgot Password?
              </span>
            </p>
          </form>

          <p className="toggle-auth">
            {isSignup ? "Already have an account?" : "New user?"}{" "}
            <span onClick={() => setIsSignup(!isSignup)}>
              {isSignup ? "Login here" : "Sign up here"}
            </span>
          </p>

          <div className="divider">or</div>

          <button className="google-btn" onClick={onGoogleLogin}>
            <img
              src="https://www.svgrepo.com/show/475656/google-color.svg"
              alt="Google"
            />
            Sign in with Google
          </button>
        </div>
      }
    </div>
  );
}
